module.exports = __webpack_public_path__ + "img/Septris-sprite-start.c3ba429d.png";